<template>
  <b-col md="6">
    <div class="h6 site-footer__title">Informazioni</div>
    <ul class="site-footer__links">
      <li class="site-footer__link">
        <a href="https://www.salabamsolutions.com" target="_blank">
          Salabam Solutions
        </a>
      </li>
      <li class="site-footer__link">
        <a :href="site.urlPrivacy" target="_blank">Privacy Policy</a>
      </li>
      <li class="site-footer__link">
        <a :href="site.urlCookiePolicy" target="_blank">Cookie policy</a>
      </li>
    </ul>
  </b-col>
</template>

<script>
  export default {
    name: 'site-footer',

    data() {
      return {
        site: this.$config.site,
      };
    },
  };
</script>